<template>
  <div class="d-flex-row game_tabs" :class="[tabs ? 'drop_show' : 'drop_hide']">
    <NuxtLinkLocale
      class="t-light game_tab white-space-no medium-l font-family-2"
      v-for="tab in getGameTabs(currentGameRoute.params?.gameSlug)"
      :to="tab.path"
      :class="[isActive(tab.name) && 'active_tab']"
      @click="sendDataLayer(tab)"
    >
      {{ tab.title }}
    </NuxtLinkLocale>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { getGameTabs } from "~/configurations/games.config";

import { useGtm } from "@gtm-support/vue-gtm";
const { getGame } = useGameStore();
const { public: publicConfig } = useRuntimeConfig();
const { nuxtEnv } = publicConfig;
const $gtm = useGtm();
const { currentGameRoute, currentGameSlug } = useGameComposable();
const { getUser } = useUserStore();
const router = useRouter();
const route = router.currentRoute;

const isActive = (pathName) => {
  if (route.value.meta?.pageInfo) {
    if (route.value.meta?.pageInfo?.name === pathName) {
      return true;
    }
  }
  return false;
};

const tabs = computed(() => {
  if (getGameTabs(currentGameRoute?.value?.params?.gameSlug)?.length > 0) {
    return true;
  }
  return false;
});

const sendDataLayer = (tab) => {
  if (nuxtEnv === "prod" && tab && tab.pack_id && window.dataLayer?.push) {
    let otherParams = {};
    if (getUser.id) {
      otherParams = {
        user_data: {
          first_name: getUser.username,
          email_address: getUser.email,
          user_id: getUser.id,
          customer_lifetime_spent: getUser.total_spent,
        },
      };
    }
    window.dataLayer?.push({
      event: "select_item",
      ecommerce: {
        items: [
          {
            item_id: "game_pack_" + tab.pack_id,
            item_name: this.$t(tab.pack_title),
            affiliation: tab.pack_slug,
            quantity: 1,
          },
        ],
      },
      ...otherParams,
    });
  }
};
</script>
